export default {
  contactHeroTitle: "联系我们",
  contactHeroSubtitle: "我们随时为您提供帮助，助您应对复杂的制药开发世界。无论您需要API制造、制剂开发还是监管支持，我们的团队随时准备为您提供协助。",
  contactGetInTouchTitle: "取得联系",
  contactOurAddress: "我们的地址",
  contactMainAddress: "67, Bazullah Road,<br />Partha Sarathy Puram,<br />T Nagar, Chennai – 600017<br />Tamil Nadu, 印度",
  contactOtherAddresses: "其他地址",
  contactAddressBangalore: "Phoenix Mall of Asia – 2号塔,<br />6层, 602单元, Yelahanka Hobli,<br />Byatarayanapura, 班加罗尔 – 560092,<br />卡纳塔克邦, 印度",
  contactAddressMumbai: "409, Bezzola Complex,<br />Sion Trombay Road,<br />Chembur, 孟买 - 400 071<br />马哈拉施特拉邦, 印度.",
  contactAddressSwitzerland: "Bahnhof-Park 4,<br />Baar 6340,<br />瑞士",
  contactEmail: "电子邮件",
  contactFormTitle: "给我们留言",
  contactFormNameLabel: "全名 *",
  contactFormNamePlaceholder: "请输入您的全名",
  contactFormEmailLabel: "电子邮件地址 *",
  contactFormEmailPlaceholder: "请输入您的电子邮件地址",
  contactFormPhoneLabel: "电话号码",
  contactFormPhonePlaceholder: "请输入您的电话号码",
  contactFormCompanyLabel: "公司",
  contactFormCompanyPlaceholder: "请输入您的公司名称",
  contactFormMessageLabel: "留言 *",
  contactFormMessagePlaceholder: "请告诉我们您的项目或咨询...",
  contactFormCharacters: "字符",
  contactFormSubmitButton: "取得联系",
  contactFormSubmitting: "发送中...",
  contactFormRecaptchaRequired: "请完成验证码",
  contactFormSuccess: "谢谢！您的消息已成功发送。我们将在24小时内回复您。",
  contactFormError: "抱歉，发送消息时出错。请重试或直接联系我们。",
};

